import DateFnsUtils from '@date-io/date-fns'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { SUCURSAL, SUCURSAL_ORIGEN } from 'Constants'
import { es } from 'date-fns/locale'

export const Fields = (info, handleChange, dataBefore) => {
  return [
    {
      label: 'Origen',
      name: 'empresa',
      options: SUCURSAL_ORIGEN,
      optionLabel: `options["label"]`,
      optionValue: 'id',
      sm: 12,
      xs: 12,
      class: 'autocomplete',
      value: info.empresa,
      onChange: (e) => {
        handleChange('empresa', e.id)

        handleChange('sucursal', null)
      },
    },
    {
      label: info.empresa === 1 ? 'Punto de venta' : 'Sucursal',
      name: `sucursal_key_${info.empresa}`,
      sm: 12,
      xs: 12,
      class: 'autocomplete',
      options:
        info.empresa === 1
          ? dataBefore.data.punto_venta
              .filter((pv) => pv.numero !== '0')
              .map((pv) => ({
                ...pv,
                nombre: `${pv.nombre} (${pv.numero})`,
              }))
          : SUCURSAL,
      optionLabel: info.empresa === 1 ? 'options["nombre"]' : 'options["label"]',
      optionValue: info.empresa === 1 ? 'numero' : 'id',
      value: info.sucursal || null,
      onChange: (e) => {
        const valorSeleccionado = info.empresa === 1 ? e.numero : e.id
        handleChange('sucursal', valorSeleccionado)
      },
    },
    {
      class: 'custom',
      component: (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
          <KeyboardDatePicker
            key="fecha"
            autoOk
            variant="inline"
            inputVariant="outlined"
            PopoverProps={{ style: { ...{ left: '40px' } } }}
            fullWidth
            onChange={(e) => {
              handleChange('fecha', e)
            }}
            disabled={dataBefore.data.permissions.ECO.adminCaja ? false : true}
            name="fecha"
            label="Fecha"
            format="dd/MM/yyyy"
            value={info.fecha}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </MuiPickersUtilsProvider>
      ),
      sm: 12,
      xs: 12,
    },
  ]
}
